<template>
  <div class='guest'>
    <div class="top">
      <h3>Guest {{ 1 + guest }}</h3>         
      <GuestButton text="x" @click="$emit('removeGuest', guest)"/>
    </div>
    <input type="text" v-model="info.first" placeholder="first name"/>
    <input type="text" v-model="info.last" placeholder="last name"/>
    <input type="email" v-model="info.email" placeholder="email address"/>      
    <GuestButton text="x" @click="$emit('removeGuest', guest)" class='add-guest-desktop'/>
  </div>
</template>

<script>
import GuestButton from "@/components/GuestButton";
export default {
  name: "GuestInfo",
  props: {
    guest: Number,
    info:Object
  },
  data() {
    return {
      first: "",
      last: "",
      email: "",
    };
  },
  components: {
    GuestButton,
  },
};
</script>

<style lang="scss" scoped>
@media (max-width:849px) {
  .add-guest-desktop {
    display:none;
  }
}
.top {
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  @media (min-width:850px) {
    display:contents;
    button {
      display:none;
    }
  }
}
.label {
    display:flex;
    justify-content: space-between;
    align-items: center;
}
h3 {
  color: var(--white);
  text-transform: uppercase;
  font-size: 1rem;  
  font-weight: 800;
}
.guest {
  display:flex;
  flex-direction: column;
  grid-template-columns: 85px 1fr 1fr 1fr 40px;
  gap:5px;
  align-items: center;    
  @media (min-width:850px) {
    display:grid;
  }
}  
input {
  font-family: inherit;
  border:none;
  outline:none;
  background: rgba(0, 0, 0, 0.40);  
  color: var(--white);
  padding: 8px 30px;
  display: inline-block;
  width:100%;
  font-weight: 800;
  box-sizing: border-box;
  &::placeholder {
    color: var(--white);
  }  
}
</style>